import { SealCategory, SelectOption } from '../../types/types';
import { unitDimensionList } from '../../data';
import { TimkenUnitDimension } from '../../../components/bearing-search/types/types';

export const sealCategories = window?._timken?.sealCategoriesWithUnits as Array<{
	code: string;
	description: string;
	unit: 'B' | 'I' | 'M';
	unitDescription: string;
}>;

export const getDimensionOptions = ( selectedCategory: SealCategory ): SelectOption<TimkenUnitDimension>[] => {
	const categoryData = sealCategories?.find( ( category ) => category.description === selectedCategory );
	const unitKey = categoryData?.unit;

	if ( ! unitKey ) {
		return [];
	}

	const supportedUnits: Record<'B' | 'I' | 'M', TimkenUnitDimension[]> = {
		M: [ 'Metric' ],
		I: [ 'Inch' ],
		B: [ 'Metric', 'Inch' ],
	};

	return unitDimensionList.filter( ( dimension ) => supportedUnits[ unitKey ].includes( dimension.value ) );
};
